/**
 * UnixDatePipe created by karora on 14/12/17.
 */
import { Pipe, PipeTransform } from '@angular/core';
// import {AppComponent} from '../app.component';
/*
 * Format a unix timestamp more prettily
 */
@Pipe({name: 'unixdate'})
export class UnixDatePipe implements PipeTransform {
  transform(value: string): string {
    try {
      let d = new Date(value);
      return d.toISOString();
/*
      return AppComponent.zpad(d.getFullYear(), 4) +
        '-' + AppComponent.zpad(1 + d.getMonth(), 2) +
        '-' + AppComponent.zpad(d.getDate(), 2) +
        'T' + AppComponent.zpad(d.getHours(), 2) +
        ':' + AppComponent.zpad(d.getMinutes(), 2) +
        ':' + AppComponent.zpad(d.getSeconds(), 2);
*/
    } catch (err) {
      console.log(err);
      return value;
    }
  }
}
